import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Map, Clock, Droplets, ShoppingBag } from 'lucide-react';
export function MechanismSection() {
  const mechanisms = [{
    icon: Map,
    title: 'Mapa 1A–4C',
    desc: 'Para dejar de copiar a la persona equivocada y entender tu textura real.'
  }, {
    icon: Clock,
    title: 'Ruta diaria de 10 min',
    desc: 'Diseñada para la vida real, para que no abandones a la semana.'
  }, {
    icon: Droplets,
    title: 'Regla Anti‑Frizz',
    desc: 'Específica para la humedad de USA, para que el clima no te arruine el día.'
  }, {
    icon: ShoppingBag,
    title: 'Kit Mínimo (Mixed)',
    desc: 'Barato vs Mejor. Para que compres menos y aciertes más.'
  }];
  return <section className="py-20 md:py-32 bg-cream-50" data-id="element-81">
      <div className="max-w-6xl mx-auto px-6" data-id="element-82">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-83">
          <FadeIn data-id="element-84">
            <h2 className="text-3xl md:text-5xl font-serif text-brown-900 mb-6" data-id="element-85">
              El mecanismo único <br data-id="element-86" />
              <span className="text-2xl md:text-3xl italic text-brown-800/60" data-id="element-87">
                (por qué esto sí se siente diferente)
              </span>
            </h2>
            <p className="text-xl text-brown-800" data-id="element-88">
              No es "otra rutina". Es un sistema de 4 piezas:
            </p>
          </FadeIn>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-89">
          {mechanisms.map((item, i) => <FadeIn key={i} delay={i * 0.15} className="h-full" data-id="element-90">
              <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-terracotta h-full hover:-translate-y-1 transition-transform duration-300" data-id="element-91">
                <div className="w-12 h-12 bg-cream-100 rounded-full flex items-center justify-center mb-6 text-terracotta" data-id="element-92">
                  <item.icon className="w-6 h-6" data-id="element-93" />
                </div>
                <h3 className="text-xl font-serif font-bold text-brown-900 mb-3" data-id="element-94">
                  {i + 1}. {item.title}
                </h3>
                <p className="text-brown-800/80 leading-relaxed" data-id="element-95">{item.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}